import { render, staticRenderFns } from "./OrderDetailRefont.vue?vue&type=template&id=0bb5dd1e&scoped=true"
import script from "./OrderDetailRefont.vue?vue&type=script&lang=js"
export * from "./OrderDetailRefont.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailRefont.vue?vue&type=style&index=0&id=0bb5dd1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5dd1e",
  null
  
)

export default component.exports